'use strict';

/**
 * Logins are e-mail addresses: PostHog's Sentry integration tags each event with a person URL ending
 * in one.
 *
 * @module monitoring.emailSanitize
 */

const EMAIL_PATTERN = /[A-Za-z0-9._+-]+(?:@|%40)[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}/g;
const REDACTED_EMAIL = '[email]';

/**
 * @param {string} value
 * @returns {string}
 */
function redactEmails(value) {
  return value.replace(EMAIL_PATTERN, REDACTED_EMAIL);
}

function isPlainObject(value) {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const prototype = Object.getPrototypeOf(value);

  return prototype === Object.prototype || prototype === null;
}

/**
 * @param {*} value
 * @returns {*} a copy of `value` with every string of its plain objects and arrays redacted
 */
function redactEmailsDeep(value) {
  if (typeof value === 'string') {
    return redactEmails(value);
  }

  if (Array.isArray(value)) {
    return value.map(redactEmailsDeep);
  }

  if (!isPlainObject(value)) {
    return value;
  }

  const redacted = {};

  Object.keys(value).forEach(function (key) {
    redacted[key] = redactEmailsDeep(value[key]);
  });

  return redacted;
}

/**
 * Sentry `beforeSend`. `sdkProcessingMetadata` holds SDK internals (scopes, raw request) that are
 * never sent.
 */
function redactEmailsFromEvent(event) {
  const redacted = redactEmailsDeep(Object.assign({}, event, { sdkProcessingMetadata: undefined }));

  redacted.sdkProcessingMetadata = event.sdkProcessingMetadata;

  return redacted;
}

export { redactEmails, redactEmailsDeep, redactEmailsFromEvent };
